import DigitalSignature from '@/components/digital-signature/DigitalSignatureModal.vue';

let VueComponent;
let component;
let preloader;

function removePreloader() {
  if (preloader) {
    preloader.remove();
    preloader = null;
  }
}

function showPreloader() {
  removePreloader();
  preloader = document.createElement('div');
  preloader.className = 'digital-signature-preloader';
  preloader.innerHTML = '<div class="preloader-box">'
    + '<div class="preloader-spinner loading"></div>'
    + '<div class="preloader-text">Verificando autorização do Bird ID...</div>'
    + '</div>';
  document.body.appendChild(preloader);
}

function close() {
  removePreloader();
  if (!component) return;
  component.show = false;
  component.$destroy();
}

function open(signFn, props = {}) {
  component = new VueComponent();

  Object.keys(props).forEach((key) => {
    component[key] = props[key];
  });

  showPreloader();

  component.show = true;
  component.sign = signFn;
  component.$on('close', close);
  component.$on('ready', removePreloader);

  component.$mount();
}

export default function install(Vue) {
  VueComponent = Vue.extend(DigitalSignature);

  Object.defineProperty(Vue.prototype, '$digitalSignature', {
    get() {
      return { open, close };
    },
  });
}
